import { EmptyState } from '@/components/EmptyState';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/PageHeader';

export const Reports = () => {
  return (
    <div className="space-y-8" data-testid="reports-page">
      <PageHeader
        title="Report"
        subtitle="Reportistica del condominio"
        actions={
          <Button className="bg-white text-primary hover:bg-white/90" data-testid="generate-report-button">
            Genera Report
          </Button>
        }
      />

      <EmptyState
        icon={FileText}
        title="Nessun report generato"
        description="Genera report personalizzati per il condominio"
      />
    </div>
  );
};